var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleDoubleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5304 2.46967C12.2375 2.17678 11.7626 2.17678 11.4697 2.46967L1.46969 12.4697C1.1768 12.7626 1.1768 13.2374 1.46969 13.5303C1.76258 13.8232 2.23746 13.8232 2.53035 13.5303L12 4.06066L21.4697 13.5303C21.7626 13.8232 22.2375 13.8232 22.5304 13.5303C22.8232 13.2374 22.8232 12.7626 22.5304 12.4697L12.5304 2.46967Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5304 10.4697C12.3897 10.329 12.1989 10.25 12 10.25C11.8011 10.25 11.6103 10.329 11.4697 10.4697L1.46969 20.4697C1.25519 20.6842 1.19103 21.0068 1.30711 21.287C1.4232 21.5673 1.69668 21.75 2.00002 21.75H22C22.3034 21.75 22.5768 21.5673 22.6929 21.287C22.809 21.0068 22.7449 20.6842 22.5304 20.4697L12.5304 10.4697Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDoubleUp);
export default __webpack_public_path__ + "static/media/angle-double-up.4bcf15b497ee50f10bebd8f990ba7ac9.svg";
export { ForwardRef as ReactComponent };